import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];

  /**
   * Downloads the latest invoice
   */
  downloadLatestInvoice(event) {
    event.preventDefault();
    // This would integrate with the payment provider's API
    alert("Invoice download functionality would be implemented here");
  }

  /**
   * Adds a new payment method
   */
  addPaymentMethod(event) {
    event.preventDefault();
    // This would integrate with the payment provider's API to add a new payment method
    // For now, show a placeholder modal or redirect to payment provider
    this.showPaymentMethodModal("add");
  }

  /**
   * Sets a payment method as default
   * @param {Event} event - The event object containing the method ID in dataset
   */
  setDefaultPaymentMethod(event) {
    event.preventDefault();
    const methodId = event.currentTarget.dataset.methodId;

    if (confirm("Set this payment method as your default?")) {
      // Make API call to set default payment method
      fetch(`/subscriptions/payment_methods/${methodId}/set_default`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content"),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            location.reload();
          } else {
            alert(
              `Failed to update payment method: ${data.error || "Unknown error"}`,
            );
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          alert("An error occurred while updating the payment method");
        });
    }
  }

  /**
   * Removes a payment method
   * @param {Event} event - The event object containing the method ID in dataset
   */
  removePaymentMethod(event) {
    event.preventDefault();
    const methodId = event.currentTarget.dataset.methodId;

    if (
      confirm(
        "Are you sure you want to remove this payment method? This action cannot be undone.",
      )
    ) {
      // Make API call to remove payment method
      fetch(`/subscriptions/payment_methods/${methodId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content"),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            location.reload();
          } else {
            alert(
              `Failed to remove payment method: ${data.error || "Unknown error"}`,
            );
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          alert("An error occurred while removing the payment method");
        });
    }
  }

  /**
   * Retries a failed payment
   * @param {Event} event - The event object containing the invoice ID in dataset
   */
  retryPayment(event) {
    event.preventDefault();
    const invoiceId = event.currentTarget.dataset.invoiceId;

    if (
      confirm(
        "Retry this failed payment? You will be charged the invoice amount.",
      )
    ) {
      // Make API call to retry payment
      fetch(`/subscriptions/invoices/${invoiceId}/retry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content"),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            alert(
              "Payment retry initiated. Please check your email for confirmation.",
            );
            location.reload();
          } else {
            alert(`Failed to retry payment: ${data.error || "Unknown error"}`);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          alert("An error occurred while retrying the payment");
        });
    }
  }

  /**
   * Shows a modal for adding/editing payment methods
   * @param {string} action - The action to perform (add/edit)
   * @param {string|null} methodId - The ID of the payment method (for edit action)
   */
  showPaymentMethodModal(action, methodId = null) {
    // This would show a modal for adding/editing payment methods
    // For now, redirect to a payment provider hosted page or show a placeholder
    alert(
      `Payment method ${action} functionality would be implemented here with payment provider integration`,
    );
  }
}
